import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

type ItemProps = {
    image?: string;
    title: string;
    description: string;
    subtitle?: string;
}
type LinkTileProps = {
    item: ItemProps;
    index: number;
    linkText?: string;
    linkURL?: string;
    textLimit?:number;
    classNames?:string
}

const LinkTile: React.FC<LinkTileProps> = ({item, linkURL, textLimit, classNames}) => {
    return (
        <a 
            className={`basic-tile-link basic-tile-wrapper ${classNames}`} 
            href={linkURL}
            >
            <Row className={`basic-tile`}>
                <Col className={`basic-tile-image`} style={{backgroundImage: `url(${item.image})`}}>
                    
                </Col>

                <Col className="basic-tile-text">
                    <h3 className="title-sans">{item.title}</h3>
                    <h5>{item.subtitle}</h5>
                    <p>{textLimit ? item.description.slice(0,textLimit)+" ..." : item.description}</p>
                </Col>
            </Row>
        </a>
    )
}
export default LinkTile;